"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TempestInc = void 0;
const Tags_1 = require("../../Tags");
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Card_1 = require("../../Card");
const ResourceType_1 = require("../../../ResourceType");
const constants_1 = require("../../../constants");
const PlaceOceanTile_1 = require("../../../deferredActions/PlaceOceanTile");
const OrOptions_1 = require("../../../inputs/OrOptions");
const SelectOption_1 = require("../../../inputs/SelectOption");
const PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const Size_1 = require("../../render/Size");
const MoonExpansion_1 = require("../../../moon/MoonExpansion");
const RedsPolicy_1 = require("../../../turmoil/RedsPolicy");
class TempestInc extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.TEMPEST_INC,
            tags: [Tags_1.Tags.SCIENCE],
            startingMegaCredits: 28,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            initialActionText: 'Raise oxygen 2 steps',
            metadata: {
                cardNumber: 'R54',
                description: 'You start with 28 M€. As your first action, raise oxygen 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(28).oxygen(2);
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action(undefined, (eb) => {
                            eb.empty().startAction.floaters(1).or();
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.action('Add 1 floater to this card, OR remove 1 floater from this card to raise any global parameter 1 step.', (eb) => {
                            eb.floaters(1).startAction.temperature(1, Size_1.Size.SMALL).slash().oxygen(1, Size_1.Size.SMALL).slash().oceans(1, Size_1.Size.SMALL);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        player.game.increaseOxygenLevel(player, 2);
        return undefined;
    }
    canAct(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        Card_1.Card.setRedsActionWarningText(player, 1, this, redsAreRuling, 'raise a global parameter', true);
        return true;
    }
    action(player) {
        if (this.resourceCount === 0)
            return this.addResource(player);
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (redsAreRuling) {
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ oceansToPlace: 1 }));
            const playerCanAffordReds = this.howToAffordReds.canAfford;
            if (!playerCanAffordReds)
                return this.addResource(player);
        }
        const opts = [];
        const spendResource = new SelectOption_1.SelectOption('Remove 1 floater to raise a global parameter 1 step', 'Remove floater', () => this.spendResource(player));
        if (this.spendResource(player).options.length > 0)
            opts.push(spendResource);
        const addResource = new SelectOption_1.SelectOption('Add 1 floater to this card', 'Add floater', () => this.addResource(player));
        opts.push(addResource);
        const orOptions = new OrOptions_1.OrOptions(...opts);
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    }
    addResource(player) {
        player.addResourceTo(this, { qty: 1, log: true });
        return undefined;
    }
    spendResource(player) {
        const orOptions = new OrOptions_1.OrOptions();
        const game = player.game;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const temperature = game.getTemperature();
        const howToAffordRedsForRaisingTemperature = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ temperatureIncrease: 1 }));
        if (!redsAreRuling || temperature === constants_1.MAX_TEMPERATURE || (redsAreRuling && howToAffordRedsForRaisingTemperature.canAfford)) {
            orOptions.options.push(new SelectOption_1.SelectOption('Increase temperature', 'Select', () => {
                const game = player.game;
                player.removeResourceFrom(this, 1);
                if (game.getTemperature() < constants_1.MAX_TEMPERATURE) {
                    game.log('${0} increased temperature 1 step', (b) => b.player(player));
                }
                game.increaseTemperature(player, 1);
                return undefined;
            }));
        }
        const howToAffordRedsForPlacingOcean = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ oceansToPlace: 1 }));
        if (!redsAreRuling || game.noOceansAvailable() || (redsAreRuling && howToAffordRedsForPlacingOcean.canAfford)) {
            orOptions.options.push(new SelectOption_1.SelectOption('Place an ocean', 'Select', () => {
                player.removeResourceFrom(this, 1);
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for ocean'));
                return undefined;
            }));
        }
        if (this.howToAffordReds !== undefined)
            player.howToAffordReds = this.howToAffordReds;
        const oxygenLevel = game.getOxygenLevel();
        const howToAffordRedsForRaisingOxygen = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ oxygenIncrease: 1 }));
        if (!redsAreRuling || oxygenLevel === constants_1.MAX_OXYGEN_LEVEL || (redsAreRuling && howToAffordRedsForRaisingOxygen.canAfford)) {
            orOptions.options.push(new SelectOption_1.SelectOption('Increase oxygen level', 'Select', () => {
                const game = player.game;
                player.removeResourceFrom(this, 1);
                if (game.getOxygenLevel() < constants_1.MAX_OXYGEN_LEVEL) {
                    game.log('${0} increased oxygen level 1 step', (b) => b.player(player));
                }
                game.increaseOxygenLevel(player, 1);
                return undefined;
            }));
        }
        const venusLevel = game.getVenusScaleLevel();
        const howToAffordRedsForRaisingVenus = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, new RedsPolicy_1.ActionDetails({ oxygenIncrease: 1 }));
        if (!redsAreRuling || venusLevel === constants_1.MAX_VENUS_SCALE || (redsAreRuling && howToAffordRedsForRaisingVenus.canAfford)) {
            if (player.game.gameOptions.venusNextExtension === true) {
                orOptions.options.push(new SelectOption_1.SelectOption('Increase Venus scale', 'Select', () => {
                    const game = player.game;
                    player.removeResourceFrom(this, 1);
                    if (game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE) {
                        game.log('${0} increased Venus scale 1 step', (b) => b.player(player));
                    }
                    game.increaseVenusScaleLevel(player, 1);
                    return undefined;
                }));
            }
        }
        if (player.game.gameOptions.moonExpansion === true) {
            const redsTaxFromRaisingMoonParameter = constants_1.REDS_RULING_POLICY_COST;
            const moonColonyRate = MoonExpansion_1.MoonExpansion.getColonyRate(player);
            if (!redsAreRuling || moonColonyRate === constants_1.MAXIMUM_COLONY_RATE || (redsAreRuling && player.canAfford(redsTaxFromRaisingMoonParameter))) {
                orOptions.options.push(new SelectOption_1.SelectOption('Increase Moon Colony rate', 'Select', () => {
                    player.removeResourceFrom(this, 1);
                    MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
                    return undefined;
                }));
            }
            const moonMiningRate = MoonExpansion_1.MoonExpansion.getMiningRate(player);
            if (!redsAreRuling || moonMiningRate === constants_1.MAXIMUM_MINING_RATE || (redsAreRuling && player.canAfford(redsTaxFromRaisingMoonParameter))) {
                orOptions.options.push(new SelectOption_1.SelectOption('Increase Moon Mining rate', 'Select', () => {
                    player.removeResourceFrom(this, 1);
                    MoonExpansion_1.MoonExpansion.raiseMiningRate(player);
                    return undefined;
                }));
            }
            const moonLogisticRate = MoonExpansion_1.MoonExpansion.getLogisticRate(player);
            if (!redsAreRuling || moonLogisticRate === constants_1.MAXIMUM_LOGISTICS_RATE || (redsAreRuling && player.canAfford(redsTaxFromRaisingMoonParameter))) {
                orOptions.options.push(new SelectOption_1.SelectOption('Increase Moon Logistics rate', 'Select', () => {
                    player.removeResourceFrom(this, 1);
                    MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
                    return undefined;
                }));
            }
        }
        return orOptions;
    }
}
exports.TempestInc = TempestInc;
//# sourceMappingURL=TempestInc.js.map